
export const awsConfig = {
    Auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_Rvz4TwcJY',
        userPoolWebClientId: '6rjuliqevfd0gvsjdl60a92t8d',
    }
}